export * from './text-area-custom-control.component';